const doc = [({"da":({"js":({"admin":({"ability_groups":({"edit":({"the_ability_group_was_saved":"Adgangsgruppen blev gemt", "new_ability_group":"Ny adgangsgruppe"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;